import { SavedViewServer, SavedViewsResponse, UserPreferences } from '@staiter/shared';
// TODO(S8+): swap stubs to shared types.
import { z } from 'zod';
import { apiRequest } from './client';

/**
 * BE-format: GET `/me/preferences` → `{ preferences: { key: value, ... } }`.
 * PUT body: `{ preferences: { key: value, ... } }` → `{ ok: true }`.
 * Frontend получает unwrapped UserPreferences (с дефолтами через Zod) для удобства.
 */
const PreferencesEnvelope = z.object({ preferences: UserPreferences });
const OkEnvelope = z.object({ ok: z.boolean() });

export async function fetchMyPreferences(): Promise<UserPreferences> {
  const resp = await apiRequest('/me/preferences', PreferencesEnvelope);
  return resp.preferences;
}

export async function updateMyPreferences(
  patch: Partial<z.input<typeof UserPreferences>>,
): Promise<UserPreferences> {
  await apiRequest('/me/preferences', OkEnvelope, {
    method: 'PUT',
    body: { preferences: patch },
  });
  // Backend возвращает только { ok: true }; делаем refetch чтобы вернуть актуальный snapshot.
  return fetchMyPreferences();
}

export async function fetchMySavedViews(resource?: string) {
  const qs = resource ? `?resource=${encodeURIComponent(resource)}` : '';
  return apiRequest(`/me/saved-views${qs}`, SavedViewsResponse);
}

export async function createSavedView(input: {
  name: string;
  resource: string;
  filters: Record<string, unknown>;
  is_shared?: boolean;
}) {
  return apiRequest('/me/saved-views', SavedViewServer, {
    method: 'POST',
    body: input,
  });
}

export async function renameSavedView(id: string, name: string) {
  return apiRequest(`/me/saved-views/${encodeURIComponent(id)}`, SavedViewServer, {
    method: 'PUT',
    body: { name },
  });
}

export async function setSavedViewShared(id: string, is_shared: boolean) {
  return apiRequest(`/me/saved-views/${encodeURIComponent(id)}`, SavedViewServer, {
    method: 'PUT',
    body: { is_shared },
  });
}

export async function setSavedViewDefault(id: string) {
  return apiRequest(`/me/saved-views/${encodeURIComponent(id)}/default`, SavedViewServer, {
    method: 'POST',
  });
}

export async function deleteSavedView(id: string) {
  return apiRequest(`/me/saved-views/${encodeURIComponent(id)}`, z.object({ ok: z.boolean() }), {
    method: 'DELETE',
  });
}
